import s from "./settings-cog.css";
export default `
<div>
  <a id="js-settings-cog-link" href="/settings" class="${s["settings-cog"]}"></a>
</div>`;
